<div class="lg:flex lg:gap-4">
  <app-card title="Dados Pessoais" class="w-full" styleClass="mb-4 lg:mb-0">
    <app-user-badge [name]="user()!.name" />
    <div class="mb-4 flex justify-end">
      <p [ngClass]="{
          'text-red-500': isUserEditable(),
          'text-gray-400': !isUserEditable()
        }" class="font-semibold mr-2">
        {{ isUserEditable() ? "Cancelar" : "Editar" }}
      </p>
      <p-toggleswitch [(ngModel)]="isUserEditable" />
    </div>
    <app-register-form [(enabled)]="isUserEditable" [initialData]="user()" (onSubmit)="updateUser($event)"
      [(isLoading)]="isUserFormLoading" />
  </app-card>
  <app-card title="Endereço" [isLoading]="isAddressCardLoading()" class="w-full">
    <div class="mb-4 flex justify-end">
      <p [ngClass]="{
          'text-red-500': isAddressEditable(),
          'text-gray-400': !isAddressEditable()
        }" class="font-semibold mr-2">
        {{ isAddressEditable() ? "Cancelar" : "Editar" }}
      </p>
      <p-toggleswitch [(ngModel)]="isAddressEditable" />
    </div>
    <app-address-form [(enabled)]="isAddressEditable" [initialData]="address()"
      (onSubmit)="createOrUpdateAddress($event)" [(isLoading)]="isAddressFormLoading" />
  </app-card>
</div>